import React from 'react';

const b = {
  fill: '#231f20'
} as const;

const c = {
  fill: 'none',
  stroke: '#231f20',
  strokeWidth: '15.76px',
  strokeMiterlimit: 10
} as const;

export default {
  svg: (
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <path {...b} d="M211.71,82.67V211.15H90.23V82.67H211.71m15.76-15.76h-153v160h153v-160Z" />
        <line {...c} x1="82.47" y1="120.41" x2="215.47" y2="120.41" />
        <rect {...b} x="103.47" y="139.91" width="22" height="22" />
        <rect {...b} x="103.47" y="175.91" width="22" height="22" />
        <rect {...b} x="140.47" y="139.91" width="22" height="22" />
        <rect {...b} x="140.47" y="175.91" width="22" height="22" />
        <rect {...b} x="176.47" y="139.91" width="22" height="22" />
        <rect {...b} x="176.47" y="175.91" width="22" height="22" />
        <circle {...b} cx="190.97" cy="97.41" r="7.5" />
        <circle {...b} cx="110.97" cy="97.41" r="7.5" />
      </g>
    </g>
  ),
  viewBox: '0 0 300 240'
};
